export class Constants {
  static period_am = "AM";
  static period_pm = "PM";
}